export default "__VITE_ASSET__D8EjNe_O__"